import { Formio, Providers } from "formiojs";
import * as _ from "lodash";

export default [
    {
        type: "input",
        input: false,
        disabled: true,
        key: "storage",
        label: "Storage",
        placeholder: "Select your file storage provider",
        weight: 0,
        tooltip: "Which storage to save the files in.",
        valueProperty: "value",
        dataSrc: "custom",
        defaultValue: "s3",
        data: {
            custom() {
                return "s3";
                // TODO: add others Providers, custom logic needed
                return _.map(Providers.getProviders("storage"), (storage, key) => {
                    return ({
                        label: storage.title,
                        value: key
                    });
                })
            }
        }
    },
    // {
    //     Type: "checkbox",
    //     Input: true,
    //     Key: "useMultipartUpload",
    //     Label: "Use the S3 Multipart Upload API",
    //     Tooltip: "The <a href='https://docs.aws.amazon.com/AmazonS3/latest/userguide/mpuoverview.html'>S3 Multipart Upload API</a> is designed to improve the upload experience for larger objects (> 5GB).",
    //     Conditional: {
    //         Json: {
    //             "===": [{
    //                 "var": "data.storage"
    //             }, "s3"]
    //         }
    //     }
    // },
    {
        label: "Multipart Upload",
        tableView: false,
        key: "multipart",
        type: "container",
        input: true,
        components: [{
            label: "Part Size (MB)",
            applyMaskOn: "change",
            mask: false,
            tableView: false,
            delimiter: false,
            requireDecimal: false,
            inputFormat: "plain",
            truncateMultipleSpaces: false,
            validate: {
                min: 5,
                max: 5000
            },
            key: "partSize",
            type: "number",
            input: true,
            defaultValue: 500
        }],
        conditional: {
            json: {
                "===": [{
                    "var": "data.useMultipartUpload"
                }, true]
            }
        }
    }, {
        type: "textfield",
        input: true,
        key: "url",
        label: "Url",
        weight: 10,
        placeholder: "Enter the url to post the files to.",
        tooltip: "See <a href='https://github.com/danialfarid/ng-file-upload#server-side' target='_blank'>https://github.com/danialfarid/ng-file-upload#server-side</a> for how to set up the server.",
        conditional: {
            json: {
                "===": [{
                    "var": "data.storage"
                }, "url"]
            }
        }
    }, {
        type: "textfield",
        input: true,
        key: "options.indexeddb",
        label: "Database",
        weight: 10,
        placeholder: "Enter the indexeddb database name",
        conditional: {
            json: {
                "in": [{
                    "var": "data.storage"
                }, ["indexeddb"]]
            }
        }
    }, {
        type: "textfield",
        input: true,
        label: "Table",
        key: "options.indexeddbTable",
        weight: 10,
        placeholder: "Enter the name for indexeddb table",
        conditional: {
            json: {
                "in": [{
                    "var": "data.storage"
                }, ["indexeddb"]]
            }
        }
    }, {
        type: "textarea",
        key: "options",
        label: "Custom request options",
        tooltip: "Pass your custom xhr options(optional)",
        rows: 5,
        editor: "ace",
        input: true,
        weight: 15,
        placeholder: "{\n      \"withCredentials\": true,\n      \"headers\": {\n        \"Authorization\": \"Basic <key>\"\n      }\n    }",
        conditional: {
            json: {
                "===": [{
                    "var": "data.storage"
                }, "url"]
            }
        }
    }, {
        type: "textfield",
        input: true,
        key: "fileKey",
        label: "File form-data key",
        weight: 17,
        placeholder: "Enter the key name of a file for form data.",
        tooltip: "Key name that you would like to modify for the file while calling API request.",
        conditional: {
            json: {
                "===": [{
                    "var": "data.storage"
                }, "url"]
            }
        }
    },
    // TODO: check if needed
    // {
    //     Type: "textfield",
    //     Input: true,
    //     Key: "dir",
    //     Label: "Directory",
    //     Placeholder: "(optional) Enter a directory for the files",
    //     Tooltip: "This will place all the files uploaded in this field in the directory",
    //     Weight: 20,
    //     Conditional: {
    //         Json: {
    //             "!==": [{
    //                 "var": "data.storage"
    //             }, "googledrive"]
    //         }
    //     }
    // },
    // TODO: check if needed
    {
        type: "textfield",
        input: true,
        key: "dir",
        label: "Folder ID",
        placeholder: "(optional) Enter an ID of the folder for the files",
        tooltip: "This will place all the files uploaded in this field in the folder",
        weight: 20,
        conditional: {
            json: {
                "===": [{
                    "var": "data.storage"
                }, "googledrive"]
            }
        }
    },
    // {
    //     Type: "textfield",
    //     Input: true,
    //     Key: "fileNameTemplate",
    //     Label: "File Name Template",
    //     Placeholder: '(optional) { {name} }-{ {guid} }"',
    //     Tooltip: "Specify template for name of uploaded file(s)." +
    //         "Regular template variables are available (`data`, `component`, `user`, `value`, `moment` etc.), also `fileName`, `guid` variables are available. `guid` part must be present, if not found in template, will be added at the end.",
    //     Weight: 25
    // },
    // {
    //     Type: "checkbox",
    //     Input: true,
    //     Key: "image",
    //     Label: "Display as image(s)",
    //     Tooltip: "Instead of a list of linked files, images will be rendered in the view.",
    //     Weight: 30
    // },
    // {
    //     Type: "checkbox",
    //     Input: true,
    //     Key: "uploadOnly",
    //     Label: "Upload Only",
    //     Tooltip: "When this is checked, will only allow you to upload file(s) and consequently the download, in this component, will be unavailable.",
    //     Weight: 33
    // },
    {
        type: "checkbox",
        input: true,
        key: "privateDownload",
        label: "Private Download",
        tooltip: "When this is checked, the file download will send a POST request to the download URL with the x-jwt-token header. This will allow your endpoint to create a Private download system.",
        weight: 31,
        conditional: {
            json: {
                "===": [{
                    "var": "data.storage"
                }, "url"]
            }
        }
    }, {
        type: "textfield",
        input: true,
        key: "imageSize",
        label: "Image Size",
        placeholder: "100",
        tooltip: "The image size for previewing images.",
        weight: 40,
        conditional: {
            json: {
                "==": [{
                    "var": "data.image"
                }, true]
            }
        }
    },
    // {
    //     Type: "checkbox",
    //     Input: true,
    //     Key: "webcam",
    //     Label: "Enable web camera",
    //     Tooltip: "This will allow using an attached camera to directly take a picture instead of uploading an existing file.",
    //     Weight: 32
    // },
    {
        type: "textfield",
        input: true,
        key: "webcamSize",
        label: "Webcam Width",
        placeholder: "320",
        tooltip: "The webcam size for taking pictures.",
        weight: 38,
        conditional: {
            json: {
                "==": [{
                    "var": "data.webcam"
                }, true]
            }
        }
    },
    // {
    //     Type: "datagrid",
    //     Input: true,
    //     Label: "File Types",
    //     Key: "fileTypes",
    //     Tooltip: "Specify file types to classify the uploads. This is useful if you allow multiple types of uploads but want to allow the user to specify which type of file each is.",
    //     Weight: 11,
    //     Components: [{
    //         Label: "Label",
    //         Key: "label",
    //         Input: true,
    //         Type: "textfield"
    //     }, {
    //         Label: "Value",
    //         Key: "value",
    //         Input: true,
    //         Type: "textfield"
    //     }]
    // },
    {
        type: "textfield",
        input: true,
        key: "filePattern",
        label: "File Pattern",
        placeholder: ".jpg,video/*,application/pdf",
        tooltip: "See <a href='https://github.com/danialfarid/ng-file-upload#full-reference' target='_blank'>https://github.com/danialfarid/ng-file-upload#full-reference</a> for how to specify file patterns.",
        weight: 50
    }, {
        type: "textfield",
        input: true,
        key: "fileMinSize",
        label: "File Minimum Size",
        placeholder: "1MB",
        tooltip: "See <a href='https://github.com/danialfarid/ng-file-upload#full-reference' target='_blank'>https://github.com/danialfarid/ng-file-upload#full-reference</a> for how to specify file sizes.",
        weight: 60
    }, {
        type: "textfield",
        input: true,
        key: "fileMaxSize",
        label: "File Maximum Size",
        placeholder: "10MB",
        tooltip: "See <a href='https://github.com/danialfarid/ng-file-upload#full-reference' target='_blank'>https://github.com/danialfarid/ng-file-upload#full-reference</a> for how to specify file sizes.",
        weight: 70
    }
];